import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import JsonLD from "../JsonLd";

export interface SpecialisedStructuredDataModuleProps {
  type: "FTB Rates";
}

export const SpecialisedStructuredData: React.FC<SpecialisedStructuredDataModuleProps> = ({ type }) => {
  const data = useStaticQuery(graphql`
    query {
      ftbRatesData {
        internal {
          content
        }
      }
    }
  `);

  if (type === "FTB Rates") {
    const content = data.ftbRatesData?.internal?.content;
    if (content) {
      return <JsonLD data={JSON.parse(content)} />;
    }

    return null;
  }

  return null;
};
